import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import { useWallet } from '../context/WalletContext';

export default function WalletScreen({ navigation }) {
  var tabState = useState('gifts');
  var tab = tabState[0];
  var setTab = tabState[1];
  var { giftCards, screenTimeRewards } = useWallet();

  var items = tab === 'gifts' ? giftCards : screenTimeRewards;

  return (
    <View style={s.container}>
      <SafeAreaView style={s.safe}>
        <View style={s.header}>
          <TouchableOpacity onPress={function() { navigation.goBack(); }}>
            <Icon name="chevron-back" size={24} color={Colors.primary} />
          </TouchableOpacity>
          <Text style={s.title}>My Wallet</Text>
          <View style={{ width: 24 }} />
        </View>
        <View style={s.tabRow}>
          <TouchableOpacity onPress={function() { setTab('gifts'); }} style={[s.tab, tab === 'gifts' && s.tabActive]}>
            <Text style={[s.tabText, tab === 'gifts' && s.tabTextActive]}>{'Gift Cards (' + giftCards.length + ')'}</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={function() { setTab('screen'); }} style={[s.tab, tab === 'screen' && s.tabActive]}>
            <Text style={[s.tabText, tab === 'screen' && s.tabTextActive]}>{'Screen Time (' + screenTimeRewards.length + ')'}</Text>
          </TouchableOpacity>
        </View>
        <ScrollView contentContainerStyle={s.content}>
          {items.length === 0 && (
            <View style={s.empty}>
              <Icon name={tab === 'gifts' ? 'gift-outline' : 'time-outline'} size={48} color={Colors.textLight} />
              <Text style={s.emptyText}>{tab === 'gifts' ? 'No gift cards yet.' : 'No screen time rewards yet.'}</Text>
            </View>
          )}
          {items.map(function(item) {
            return (
              <View key={item.id} style={s.rewardRow}>
                <View style={[s.rewardIcon, { backgroundColor: tab === 'gifts' ? Colors.primary : Colors.screenTime }]}>
                  {tab === 'gifts' ? (
                    <View style={s.giftLogo}><Text style={[s.giftLogoText, { color: item.color }]}>{item.store}</Text></View>
                  ) : (
                    <Icon name="time" size={24} color="#fff" />
                  )}
                </View>
                <View style={s.rewardInfo}>
                  <Text style={s.rewardName}>{tab === 'gifts' ? item.store : item.app}</Text>
                  <Text style={s.rewardDate}>{item.date}</Text>
                </View>
                <Text style={[s.rewardAmount, { color: tab === 'gifts' ? Colors.accent : Colors.screenTime }]}>
                  {tab === 'gifts' ? item.amount : item.minutes + 'min'}
                </Text>
              </View>
            );
          })}
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

var s = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 16, paddingVertical: 12 },
  title: { fontSize: 20, fontWeight: '700', color: Colors.textDark },
  tabRow: { flexDirection: 'row', gap: 8, paddingHorizontal: 20, marginBottom: 16 },
  tab: { paddingVertical: 8, paddingHorizontal: 18, borderRadius: 20, backgroundColor: 'rgba(255,255,255,0.5)' },
  tabActive: { backgroundColor: Colors.primary },
  tabText: { fontSize: 13, fontWeight: '600', color: Colors.textMid },
  tabTextActive: { color: '#fff' },
  content: { paddingHorizontal: 20, paddingBottom: 40 },
  empty: { alignItems: 'center', paddingTop: 60 },
  emptyText: { color: Colors.textLight, marginTop: 12, fontSize: 14 },
  rewardRow: { flexDirection: 'row', alignItems: 'center', gap: 14, padding: 14, backgroundColor: Colors.card, borderRadius: 14, marginBottom: 8 },
  rewardIcon: { width: 48, height: 48, borderRadius: 12, alignItems: 'center', justifyContent: 'center' },
  giftLogo: { width: 28, height: 20, borderRadius: 4, backgroundColor: '#fff', alignItems: 'center', justifyContent: 'center' },
  giftLogoText: { fontSize: 6, fontWeight: '800', textAlign: 'center' },
  rewardInfo: { flex: 1 },
  rewardName: { fontSize: 15, fontWeight: '700', color: Colors.textDark },
  rewardDate: { fontSize: 12, color: Colors.textLight, marginTop: 2 },
  rewardAmount: { fontSize: 20, fontWeight: '800' },
});
